export enum MARKETPLACE_CATEGORY {
    GIFTING = "GIFTING",
}

export enum MARKETPLACE_BUSINESS_LINE {
    GIFTING = "GIFTING",
}

export enum MARKETPLACE_ID {
    SWIGGY = 1,
}
